module.exports = __webpack_public_path__ + "static/img/pic.13cbe2e5.svg";